/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ApplicationCode {
        public uniqueIdentifier: string;
        public codeGroup: string;
        public shortDescription: string;
        public longDescription: string;
        public isActive: boolean;

        constructor(uniqueIdentifier? : string, codeGroup? : string, shortDescription? : string, longDescription? : string, isActive? :boolean) {
            this.uniqueIdentifier = uniqueIdentifier;
            this.codeGroup = codeGroup;
            this.shortDescription = shortDescription;
            this.longDescription = longDescription;
            this.isActive = isActive;
        }

        public createFormattedString(displayFormat: string) : string {
            return displayFormat
                .replace("{id}", this.uniqueIdentifier)
                .replace("{codeGroup}", this.codeGroup)
                .replace("{shortDescription}", this.shortDescription)
                .replace("{longDescription}", this.longDescription)
                .replace("{isActive}", this.isActive ? "True" : "False");
        }
    }
}